import { Link } from 'react-router-dom';
import { Settings, Users, Truck } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card.jsx';
import { Button } from '@/components/ui/button.jsx';
import AdminPageHeader from './ui/AdminPageHeader.jsx';

const quickLinks = [
  {
    title: 'Clientes',
    description: 'Gestioná altas, ediciones y bajas de clientes.',
    to: '/admin/clientes',
    icon: Users,
  },
  {
    title: 'Vehículos',
    description: 'Consultá y administrá la flota disponible.',
    to: '/admin/vehiculos',
    icon: Truck,
  },
];

export default function DashboardAdmin() {
  return (
    <div className="space-y-4">
      <AdminPageHeader
        title="Administración"
        breadcrumbs={[
          { label: 'Inicio', href: '/cargas' },
          { label: 'Administración' },
        ]}
        description="Panel central para gestionar clientes y vehículos."
      />

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {quickLinks.map(link => {
          const Icon = link.icon;
          return (
            <Card key={link.title} className="h-full">
              <CardHeader className="flex flex-row items-center justify-between gap-4 border-b border-transparent pb-0">
                <div>
                  <CardTitle>{link.title}</CardTitle>
                  <p className="text-sm text-slate-500 dark:text-slate-400">{link.description}</p>
                </div>
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-navy/10 text-brand-navy dark:bg-slate-700/60 dark:text-slate-100">
                  <Icon size={22} />
                </span>
              </CardHeader>
              <CardContent className="pt-5">
                <Button asChild className="w-full justify-center">
                  <Link to={link.to}>Ir a {link.title}</Link>
                </Button>
              </CardContent>
            </Card>
          );
        })}

        <Card className="h-full">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Settings size={18} />
              Configuración rápida
            </CardTitle>
            <p className="text-sm text-slate-500 dark:text-slate-400">
              Ajustá parámetros clave para el equipo administrativo.
            </p>
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="text-sm text-slate-600 dark:text-slate-300">
              Accedé a la configuración de estados, permisos y preferencias del módulo de administración.
            </p>
            <Button variant="outline" asChild className="w-full justify-center">
              <Link to="/admin/clientes">Gestionar clientes</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
